import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Table from '@ui/Table'

import indexStyles from '@styles/indexPage'

const EMPTY = '—'

// O backend já entrega o diff aberto campo a campo, inclusive as chaves de
// dentro do jsonb `data`. Aqui só falta rotular e formatar.
const fieldLabel = field =>
  I18n.t(`v4/organization_asset.timeline.fields.${field}`, { defaultValue: field })

const formatValue = value => {
  if (value === null || value === undefined || value === '') return EMPTY
  if (typeof value === 'boolean') return value ? I18n.t('actions.yes', { defaultValue: 'true' }) : I18n.t('actions.no', { defaultValue: 'false' })
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

const formatChanges = changes =>
  (changes || [])
    .map(({ field, from, to }) => `${fieldLabel(field)}: ${formatValue(from)} → ${formatValue(to)}`)
    .join('\n')

const Timeline = ({ model, classes, organization, equipment, o }) => (
  <Paper className={classes.page__wrapper} elevation={0}>
    <header className={classes.page__header}>
      <Typography component='h2' variant='h5'>
        {I18n.t('v4/organization_asset.timeline.title')}
        {equipment ? ` — ${equipment.name}` : ''}
      </Typography>

      {equipment &&
        <Typography component='p' variant='body2' color='textSecondary'>
          {`#${equipment.id}`}
          {equipment.identifier ? ` · ${I18n.t('v4/organization_asset.table.identifier')}: ${equipment.identifier}` : ''}
          {equipment.barcode ? ` · ${I18n.t('v4/organization_asset.table.barcode')}: ${equipment.barcode}` : ''}
        </Typography>
      }
    </header>

    <Typography component='p' variant='caption' color='textSecondary' className={classes.notice}>
      {I18n.t('v4/organization_asset.timeline.coverage_notice')}
    </Typography>

    <Table
      tableKey='admin-organizations-assets-timeline'
      components={{
        Container: props => <div>{props.children}</div>
      }}
      columns={[
        { title: I18n.t('v4/organization_asset.timeline.when'), field: 'created_at' },
        { title: I18n.t('v4/organization_asset.timeline.user'), field: 'user' },
        {
          title: I18n.t('v4/organization_asset.timeline.event'),
          field: 'event',
          render: rowData => I18n.t(`v4/organization_asset.timeline.events.${rowData.event}`, { defaultValue: rowData.event })
        },
        {
          title: I18n.t('v4/organization_asset.timeline.changes'),
          field: 'changes',
          sorting: false,
          cellStyle: { whiteSpace: 'pre-line' },
          render: rowData => formatChanges(rowData.changes) || EMPTY
        },
        { title: I18n.t('v4/organization_asset.timeline.justification'), field: 'justification' }
      ]}
      data={model.entries}
      options={{ showTitle: false, sorting: true }}
    />

    <footer className={classes.footer}>
      <Button
        variant='outlined'
        color='primary'
        href={`/v4/o/${o}/admin/organizations/${organization ? organization.id : ''}/assets`}
      >
        {I18n.t('actions.back')}
      </Button>
    </footer>
  </Paper>
)

Timeline.propTypes = {
  model: PropTypes.shape({
    entries: PropTypes.array
  }),
  organization: PropTypes.object,
  equipment: PropTypes.object,
  o: PropTypes.string
}

Timeline.defaultProps = {
  model: { entries: [] }
}

const Styles = theme => ({
  ...indexStyles(theme),
  notice: {
    marginBottom: theme.spacing.unit * 2
  },
  footer: {
    marginTop: theme.spacing.unit * 3
  }
})

export default withStyles(Styles)(Timeline)
